"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeExdateFrom = void 0;
const timezone_date_1 = require("./timezone-date");
const removeExdateFrom = ({ exdate, date, timezone = 'Europe/Paris', }) => {
    return exdate.filter((item) => (0, timezone_date_1.formatToDateTimeInTz)({ date: item, timezone }) !==
        (0, timezone_date_1.formatToDateTimeInTz)({ date, timezone }));
};
exports.removeExdateFrom = removeExdateFrom;
